<div *ngFor="let item of detections" [style]="getStyle(item)" (click)="onClick(item)"></div>
<ng-content></ng-content>
